import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services/token/token.service';
import { USER_ROLES } from '../constants/app.constants';

/** Route guard that restricts access to Super Admin and Admin users only. */
export const superAdminGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const user = tokenService.user();

  if (
    user?.role === USER_ROLES.SUPER_ADMIN ||
    user?.role === USER_ROLES.ADMIN
  ) {
    return true;
  }

  return router.createUrlTree(['/home/dashboard']);
};
